const { NODE_ENV, REACT_APP_STAGE } = process.env;

export const isDev = NODE_ENV === 'development';
export const isProd = NODE_ENV === 'production' && REACT_APP_STAGE !== 'true';
export const isStaging = NODE_ENV === 'production' && REACT_APP_STAGE === 'true';

export const env: 'development' | 'staging' | 'production' = (() => {
    if (isProd) {
        return 'production';
    }
    if (isStaging) {
        return 'staging';
    }
    return 'development';
})();
